import template from './settlement-name.jade';

export default angular.module('cian.addForm.settlementName', []).directive('cianAfAboutObjectSettlementName', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller: [
    'deviceService',
    function (deviceService) {
      this.isMobile = deviceService.isMobile;
    },
  ],
  controllerAs: 'settlementName',
  template,
})).name;
